import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Grid,
} from "@chakra-ui/react";
import { LoadingOverlay } from "@components/ui-kit";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { withCan } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  useFetchBasicData,
  useFetchBrandsData,
  useFetchDocumentsData,
  useFetchProjectsSimpleData,
  useFetchUnusedPaidProformaInvoices,
  usePresetVatPercentInformative,
} from "../hooks";
import { useInvoiceStore } from "../store";
import { FooterNav } from "./FooterNav";
import { Header } from "./Header";
import { SideNav } from "./SideNav";

export const Container = withCan(
  {
    do: [
      "requestForInvoicing_create_all",
      "requestForInvoicing_create_own",
      "requestForInvoicing_create_team",
      "requestForInvoicing_update_all",
      "requestForInvoicing_update_own",
      "requestForInvoicing_update_team",
    ],
  },
  observer(function Container() {
    const store = useInvoiceStore();
    const [parent] = useAutoAnimate<HTMLDivElement>();

    useFetchBasicData();
    useFetchBrandsData();
    useFetchProjectsSimpleData();
    useFetchUnusedPaidProformaInvoices();
    useFetchDocumentsData();
    usePresetVatPercentInformative();
    // useFetchInvoiceNo();

    const Step = store.currentStep.content;

    return (
      <React.Fragment>
        <Header />
        <Grid
          gap="4"
          templateColumns={{
            base: "1fr",
            md: "0.5fr 1fr",
          }}
        >
          <Box flex="1 1 24rem">
            <SideNav />
          </Box>

          <Box ref={parent} flex="2 2 48rem" minW="0">
            {store.form.steps[store.currentStep.id].formError && (
              <Alert mb="4" rounded="lg" status="error">
                <AlertIcon />
                <AlertDescription>
                  {store.form.steps[store.currentStep.id].formError}
                </AlertDescription>
              </Alert>
            )}

            <LoadingOverlay isLoading={store.significantLoading}>
              <Step />
            </LoadingOverlay>
            <FooterNav />
          </Box>
        </Grid>
      </React.Fragment>
    );
  }),
);
